import { c as _c } from "react/compiler-runtime";
import { cx, cva, type VariantProps } from 'class-variance-authority';
import ModalCloseButton from './ModalCloseButton';
type ModalHeaderProps = VariantProps<typeof modalVariant> & {
  title?: React.ReactNode;
  description?: React.ReactNode;
  onClose?: () => void;
  className?: string;
};
const modalVariant = cva(['mb-1 text-primary'], {
  variants: {
    titleSize: {
      md: 'text-xl font-bold'
    }
  },
  defaultVariants: {
    titleSize: 'md'
  }
});
export default function ModalHeader(t0) {
  const $ = _c(16);
  const {
    title,
    titleSize,
    description,
    onClose,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("shrink-0 px-6 pt-6 sm:px-10 sm:pt-10", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title || $[3] !== titleSize) {
    t2 = title && <h2 className={modalVariant({
      titleSize
    })}>{title}</h2>;
    $[2] = title;
    $[3] = titleSize;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== description) {
    t3 = description && <p className="pt-4 text-sm font-normal text-blue-700">{description}</p>;
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <header className={t1}>{t2}{t3}</header>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onClose) {
    t5 = onClose && <ModalCloseButton onClick={onClose} />;
    $[11] = onClose;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}